import { createStore } from 'vuex'
import axios from "axios";

const BaseUrl :string = process.env.VUE_APP_API;
export interface StateI {
    user: {
        token: string | null,
        data: {
            username: string | null,
            user_id: string | null
        }
    },
    isSaveBtnVisible: boolean,
    paymentGatewayLogs: NonNullable<unknown>[]
}

export interface CreatedAtI {
    created_at: string | number | Date;
}

export interface ResultI {
    token: string | null,
    data: {
        username: string ,
        user_id: string ,
        access_token: string ,
    }
}

export interface PaymentGatewayLogsParamsI {
    page: number,
    startDate: string | null,
    endDate: string | null,
    amount: number | null,
    widgetName: string | null,
    reference: string | null,
    type: string | null,
    status: string | null,
}

export default createStore({
  state: {
      user:{
          data:{
              username: sessionStorage.getItem('username'),
              user_id: null
          },
          token: sessionStorage.getItem("TOKEN")
      },

      widgets: {},
      isSaveBtnVisible: false,
      paymentGatewayLogs: [],
  },

  getters: {
    getSaveBtnVisibility(state) {
        return state.isSaveBtnVisible;
    },
  },

  mutations: {
      setSaveBtnVisibility(state, payload) {
        state.isSaveBtnVisible = payload;
      },

      logout: (state:StateI) => {
          state.user.token = null;
          sessionStorage.removeItem("TOKEN")
          sessionStorage.removeItem("username")
          sessionStorage.removeItem("user_id")
          location.reload();
      },
      setUser: (state:StateI, res:ResultI) => {
          state.user.data.username = res.data.username;
          state.user.data.user_id = res.data.user_id;
          state.user.token = res.data.access_token;
          sessionStorage.setItem('TOKEN' , res.data.access_token)
          sessionStorage.setItem('username' , res.data.username)
          sessionStorage.setItem('user_id' , res.data.user_id)
      },
      setWidgets:(state, res) => {
          state.widgets = res.data.sort((a: CreatedAtI, b: CreatedAtI) => (
              +new Date(b.created_at) - +new Date(a.created_at)
          ));
      },
      setPaymentGatewayLogs(state, res) {
        state.paymentGatewayLogs = res.data;
      }
  },
  actions: {
      logout({commit}){
          commit("logout")
      },
      login({ commit }, user){
          return new Promise((resolve, reject) => {
              axios.post(BaseUrl + 'v3/oauth/login', user)
                  .then(res => {
                      commit("setUser", res)
                      window.document.location = process.env.VUE_APP_HOME;
                  }).catch((error) => {
                  reject(error);
              })
          })
      },
      widgets({commit}){
          const token = this.state.user.token
          const config = {
              headers: { Authorization: `Bearer ${token}` }
          };
          return new Promise((resolve, reject) => {
              axios.get(BaseUrl + 'v3/get-widgets', config)
                  .then(res => {
                      commit("setWidgets", res)
                  }).catch((error) => {
                      reject(error);
                  })
          })
      },
    getPaymentGatewayLogs({commit}, params: PaymentGatewayLogsParamsI){
        const token = this.state.user.token
        const config = {
            headers: { Authorization: `Bearer ${token}` },
            params
        };
        return new Promise((resolve, reject) => {
            axios.get(BaseUrl + 'v4/payment-gateway-logs', config)
                .then(response => {
                    commit('setPaymentGatewayLogs', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log(error);
                    reject(error)
                })
        })
    },
    // Full lifecycle of one transaction (setup, outcome, webhooks) — resolves
    // with the response data, nothing is committed to state.
    getPaymentGatewayLogTransaction(context, params: { transactionId: string | null, reference: string | null }){
        const token = this.state.user.token
        const config = {
            headers: { Authorization: `Bearer ${token}` },
            params
        };
        return axios.get(BaseUrl + 'v4/payment-gateway-logs/transaction', config)
            .then(response => response.data)
    },
    // Downloads the current filtered result set as a CSV file.
    exportPaymentGatewayLogs(context, params: PaymentGatewayLogsParamsI){
        const token = this.state.user.token
        const config = {
            headers: { Authorization: `Bearer ${token}` },
            params,
            responseType: 'blob' as const,
        };
        return axios.get(BaseUrl + 'v4/payment-gateway-logs/export', config)
            .then(response => {
                const url = window.URL.createObjectURL(response.data as Blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'payment-gateway-logs.csv';
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
    }
  },
  modules: {
  }
})
